import React from 'react';
import { ControllerIcon } from './ControllerIcon';
export function Footer() {
  return <footer className="bg-gameu-base pt-20 pb-10 border-t border-gameu-elevated" data-id="element-28">
      <div className="max-w-7xl mx-auto px-6" data-id="element-29">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16" data-id="element-30">
          <div data-id="element-31">
            <div className="flex items-center gap-2 mb-6" data-id="element-32">
              <ControllerIcon variant="full" className="w-6 h-6 text-gameu-accent" data-id="element-33" />
              <span className="font-serif text-3xl tracking-wide text-gameu-text mt-1" data-id="element-34">
                Gameu
              </span>
            </div>
            <p className="text-gameu-muted text-sm max-w-xs" data-id="element-35">
              The premier monetization and SEO agency for gaming review and
              comparison platforms.
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-12 md:gap-24" data-id="element-36">
            <div data-id="element-37">
              <h4 className="text-gameu-text font-medium mb-4" data-id="element-38">Location</h4>
              <p className="text-gameu-muted text-sm" data-id="element-39">
                Limassol, Cyprus
                <br data-id="element-40" />
                (European Union)
              </p>
            </div>

            <div data-id="element-41">
              <h4 className="text-gameu-text font-medium mb-4" data-id="element-42">Navigation</h4>
              <ul className="space-y-2 text-sm text-gameu-muted" data-id="element-43">
                <li data-id="element-44">
                  <a href="#problems" className="hover:text-gameu-accent transition-colors" data-id="element-45">
                    Problems
                  </a>
                </li>
                <li data-id="element-46">
                  <a href="#services" className="hover:text-gameu-accent transition-colors" data-id="element-47">
                    Services
                  </a>
                </li>
                <li data-id="element-48">
                  <a href="#results" className="hover:text-gameu-accent transition-colors" data-id="element-49">
                    Results
                  </a>
                </li>
                <li data-id="element-50">
                  <a href="#pricing" className="hover:text-gameu-accent transition-colors" data-id="element-51">
                    Pricing
                  </a>
                </li>
                <li data-id="element-52">
                  <a href="#team" className="hover:text-gameu-accent transition-colors" data-id="element-53">
                    Team
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gameu-elevated text-xs text-gameu-muted" data-id="element-54">
          <p data-id="element-55">© 2026 Gameu. All rights reserved.</p>
          <ControllerIcon variant="dpad" className="w-4 h-4 mt-4 md:mt-0 opacity-50" data-id="element-56" />
        </div>
      </div>
    </footer>;
}